import styled from 'styled-components';

export const Input = styled.input`
  width: ${props => props.width || '100%'};
  padding: 1rem;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid var(--light-periwinkle);
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: ${props => props.accentColor || 'var(--ultramarine-blue)'};
  }
`;
